<div class="kpsys-logo-container">
    KP-sys s.r.o.
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    @kpsys-logo-color: #6B9AB8;

    .kpsys-logo-container {
        color: @kpsys-logo-color;
        display: flex;
        align-items: center;
    }
</style>